module.exports = __webpack_public_path__ + "img/pdf.6657991a.jpg";